import { ApolloClientOptions } from '@apollo/client/core';

export abstract class ApolloConnectionService {
	public abstract createApolloClientOptions(): ApolloClientOptions<unknown>;
}
